import { convertToPhoneNumbers } from "components/PhoneInput";
import { ContactFormState } from "./models";
import { findCountryById, findStateById } from "utilities/countrystateutils";
import moment from "moment";

export const getInstruction = (contact: server.dto.Contact, contactForm: ContactFormState, partial: Partial<server.dto.UpdateContactDetailsInstruction>): server.dto.UpdateContactDetailsInstruction => ({
  additional: contactForm.additionalInformation,
  address: {
    addressLine1: contactForm.homeAddress.addressLine1,
    addressLine2: contactForm.homeAddress.addressLine2,
    city: contactForm.homeAddress.city,
    postalCode: contactForm.homeAddress.postalCode,
    stateId: contactForm.homeAddress.state.key,
  },
  attn: contactForm.attn,
  birthdate: contactForm.birthdate?.toDate(),
  birthplace: contactForm.birthplace,
  contactId: contact.contactId,
  culture: contactForm.culture,
  department: contactForm.department,
  emailAddresses: contactForm.emailAddresses,
  emailBlacklisted: contactForm.isEmailBlacklisted,
  facebook: contactForm.facebook,
  landlineNumbers: convertToPhoneNumbers(contactForm.landlineNumbers),
  maritalStatus: contactForm.maritalStatus ?? "unknown",
  mobileNumbers: convertToPhoneNumbers(contactForm.mobileNumbers),
  name: {
    first: contactForm.firstName,
    insertion: contactForm.insertion,
    last: contactForm.lastName,
  },
  nationality: contactForm.nationality,
  networkPath: contactForm.networkPath,
  ownerUserId: contactForm.owner.userId,
  passportExpiration: contactForm.passportExpiration?.toDate(),
  passportIssued: contactForm.passportIssued?.toDate(),
  passportName: contactForm.passportName,
  passportNumber: contactForm.passportNumber,
  position: contactForm.position,
  salutation: contactForm.salutation,
  socialSecurity: contactForm.socialSecurity,
  statusId: contactForm.status.statusId,
  twitter: contactForm.twitter,
  website: contactForm.website,
  gender: contactForm.gender,
  ...partial
});

export const contactToFormState = (contact: server.dto.Contact): ContactFormState => ({
  firstName: contact.name.firstName ?? "",
  insertion: contact.name.insertion ?? "",
  lastName: contact.name.lastName ?? "",
  emailAddresses: contact.emailAddresses.join(";") ?? "",
  isEmailBlacklisted: contact.emailBlacklisted,
  mobileNumbers: contact.mobileNumbers.join(";") ?? "",
  gender: contact.gender,
  position: contact.position ?? "",
  department: contact.department ?? "",
  culture: contact.culture,
  landlineNumbers: contact.landlineNumbers.join(";") ?? "",
  salutation: contact.salutation ?? "",
  homeAddress: {
    addressLine1: contact.address.addressLine1 ?? "",
    addressLine2: contact.address.addressLine2 ?? "",
    postalCode: contact.address.postalCode ?? "",
    city: contact.address.city ?? "",
    state: findStateById(contact.address.stateId),
    country: findCountryById(contact.address.country)
  },
  status: contact.status,
  owner: contact.owner,
  twitter: contact.twitter ?? "",
  website: contact.website ?? "",
  networkPath: contact.networkPath ?? "",
  facebook: contact.facebook ?? "",
  socialSecurity: contact.socialSecurity ?? "",
  birthdate: contact.birthdate ? moment.utc(contact.birthdate) : undefined,
  birthplace: contact.birthPlace ?? "",
  maritalStatus: contact.maritalStatus,
  additionalInformation: contact.additional ?? "",
  nationality: contact.nationality ?? "",
  passportName: contact.passport?.name ?? "",
  passportNumber: contact.passport?.number ?? "",
  passportIssued: contact.passport?.issued ? moment.utc(contact.passport?.issued) : undefined,
  passportExpiration: contact.passport?.expiration ? moment.utc(contact.passport?.expiration) : undefined,
  attn: contact.attn ?? ""
})